import React from 'react';
import './App.css';
import Footer from './components/Footer/Footer';
import Scroll from './components/Scroll/Scroll';

function App() {
  return (
    <div className="App">
      <Scroll />
      <Footer />
    </div>
  );
}

export default App;